<template>
    <section>
        <o-datetimepicker inline />
    </section>
</template>
